import React, { Component } from 'react';
import '../adminDash.css';
// import globalVariables from "../global_files/globalVariables";
// import { post, get } from '../global_files/serverRequests';
// import { displayDateTime, isEmpty } from '../global_files/validation';
// import Chart from 'react-apexcharts';// import ChartDataLabels from 'chartjs-plugin-datalabels';
// import HomepageProgressbars from '../Global_files/HomepageProgressbars';
// import { Link } from 'react-router-dom';
import { get } from '../../custom_libraries/serverRequests';
import urls from '../../custom_libraries/urls';
import globalVariables from '../../custom_libraries/globalVariables';
import withNavigate from '../../Global_files/WithNavigate'; 
import { Button} from '@mui/material';
import { getFreshToken } from '../../custom_libraries/serverRequests';
import Navigationbar from '../Navigationbar';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Chart from "react-apexcharts";
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Typography,
  Box,Tabs, Tab
 
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
// import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import DirectionsCarFilledRounded from '@mui/icons-material/DirectionsCarFilledRounded';
// import TwoWheelerIcon from '@mui/icons-material/TwoWheeler';
import TwoWheelerRounded from '@mui/icons-material/TwoWheelerRounded';
// import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import DirectionsWalkRounded from '@mui/icons-material/DirectionsWalkRounded';
// import CarIcon from '../../assets/icons8-car-30.png';
// import personIcon from '../../assets/icons8-person-48.png';
// import motorIcon from '../../assets/icons8-bike-50.png';
// import GppGoodIcon from '@mui/icons-material/GppGood';
// import RemoveModeratorIcon from '@mui/icons-material/RemoveModerator';
// import LockRoundedIcon from '@mui/icons-material/LockRounded';
// import LockOpenRoundedIcon from '@mui/icons-material/LockOpenRounded';
// import CameraAltIcon from '@mui/icons-material/CameraAlt';
// import NoPhotographyIcon from '@mui/icons-material/NoPhotography';
import VideocamIcon from '@mui/icons-material/Videocam';
// import VideocamOffIcon from '@mui/icons-material/VideocamOff';

//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      // default: "#0d0d0d",
      // paper: "#000000",
      default: "#191e29",
      paper: "#212632",
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------

class Home extends Component {

    constructor(props) {
        super(props);
      //   this.state = {
      //     matrixData: null, // Initialize state for matrixData
      // };
        this.state = {
          live_devices : 0,
          total_devices : 0,
          live_cameras: 0,
          offline_cameras: 0,
          healthy_view: 0,
          currently_recording: 0,
          healthy_hdd: 0,
          total_hdd: 0,
          cameras_meeting_the_recording_policy:0,
          cameras_recording_policy_unmatched: 0,
          loading: true,
          dataAvailable : false,
          activeTab: 0, // Default to the first tab (General Info)
          errorPage: 1,
          warningPage: 1,
          errorRecords: [],
          warningRecords: [],
          errorTotalPages: 1,
          warningTotalPages: 1,
          showOfflineDetails: false,
          offlineCameraDetails: [],
          selectedVideoTab: 0, // 0 = unstable, 1 = 24h, 2 = 7d
          offlineCameraTab: false,
          offlineCameraList: [],
          disarmedDevicesList: [],
          disarmedPage: 1,
          disarmedTotalPages: 1,
          totalAlertResolvedCount: "-",

          series: [0, 0],
          totalValue : 0,
          options: {
            chart: {
              height: 350,
              type: 'radialBar',
              background: "transparent",
            },
            plotOptions: {
              radialBar: {
                startAngle: 0,
                endAngle: 360, // Full circle
                hollow: {
                margin: 5,
                size: "50%",
                },
                track: {
                show: true, // Show background track
                strokeWidth: "100%",
                },
                dataLabels: {
                  name: {
                    fontSize: '22px',
                  },
                  value: {
                    fontSize: '16px',
                    show: true, // Show raw values
                  },
                  total: {
                    show: true,
                    // showAlways: true,
                    label: 'Total Cameras',
                    formatter: () => {
                      // Use an arrow function to preserve `this` context
                      return this.state.totalValue;
                    },
                  }
                }
              }
            },
            colors: ['#32cd32', '#FFC300'],
            labels: [ 'Cameras Live', 'Cameras down'],
            tooltip: {
                enabled: true,
                y: {
                  formatter: (value, opts) => {
                    // Use the raw value instead of the percentage
                    const rawValue = this.state.series[opts.seriesIndex];
                    return `${rawValue}`; 
                    // Customize tooltip content
                  },
                },
              },
            theme: {
              mode: "dark", // 🔥 IMPORTANT
            },

          }, 
          //Video Analytics Data 
          objectCounts: {
                person: 0,
                car: 0,
                motorbike: 0,
          },
          videoDetectionData: [],
          videoDetectionPage: 1,
          videoDetectionTotalPages: 1,
          videoAnalyticsChartData: [], // ✅ Make sure this is always an array
          videoAnalyticsRange: '7d',
          offlineCameras24H: [],
          totalOffline24H: 0,
          loadingOffline: false,
          offlinePage: 1,
          offlineTotalPages: 1,
        };
    }

    componentDidMount() {
    setTimeout(() => {
          this.validateSignedIn();
      }, 0);
      
      this.getMatrixCount();
      this.fetchErrorRecords(1);
      this.fetchWarningRecords(1);
      this.fetchObjectCounts(); // Fetch video analytics object counts
      // this.fetchVideoDetectionData();  // Uncomment if you need video detection data, currently this function is not in use, reducing unwanted API call on every page load
       this.fetchVideoAnalyticsChartData('7d');
        if (this.state.selectedVideoTab === 0) {
        this.fetchDisarmedDevices(1);
      }
    }

    componentDidUpdate(prevProps) {
      if (prevProps.matrixData !== this.props.matrixData && this.props.matrixData) {
        console.log("Setting matrix data:", this.props.matrixData); // Debugging log
        this.setMatrixData(this.props.matrixData);
        // this.setState({ matrixData: this.props.matrixData });
      }
    }

    validateSignedIn = async () => {
      try {
        let is_fresh_token = await getFreshToken();
        console.log("Fresh Token:", is_fresh_token);
    
        if (!is_fresh_token) {
          console.log("Navigating to login...");
          this.props.navigate("/");
          return;
        }
        const license_warning = localStorage.getItem(globalVariables.LICENSE_WARNING);
        if (license_warning && license_warning.length > 0){
          alert(license_warning)
        }
      } catch (error) {
        console.error("Error in validateSignedIn:", error);
      }
      }
      /** 
   * getMatrixCount() function fetches the count of live, down camera and device , count of currently recording cams, count of healthy hdd  
  **/
  getMatrixCount = async () => {

    try {
      let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`
      }
      const response1 = await get(urls.STATUS_MATRIX, headers); // Perform the API call using the constructed URL
        console.log("API Response for getMatrixCount response:", response1);
      let response = response1.data;
      // console.log("API Response for getMatrixCount response:", response);
      if (!response || response['devices'].total === 0 || Object.keys(response).length === 0 ) {
        // setDataAvailable(false);
        this.setState({dataAvailable: false})
        console.error(" error1 fetching getMatrixCount from API:");
      }
      else{
        this.setState({
          dataAvailable: true,
          series: [
            response['cameras'].live,
            response['cameras'].down,
          ],
          totalValue: response['cameras'].total,
          live_cameras: response['cameras'].online,
          offline_cameras : response['cameras'].offline,

          ai_warning: response['ai_warning'].count,
          ai_warning_records: response['ai_warning'].records,

          cameras_recording_policy_unmatched: response['errors']["cameras_recording_policy_unmatch"].count,
          cameras_recording_policy_unmatched_records: response['errors']["cameras_recording_policy_unmatch"].records,

          hdds_unmatched: response['errors']["hdds_unmatch"].count,
          hdds_unmatched_records: response['errors']["hdds_unmatch"].records,

          // offline_cameras: response['errors']["offline_cameras"].count,
          offline_cameras_records: response['errors']["offline_cameras"].records,

          time_mismatch: response['errors'].time_mismatch,
          time_mismatch_records: response['errors'].time_mismatch_records,

          // live_devices : response['devices'].active,
          // total_devices : response['devices'].total,

          // healthy_view: response.healthy_views,
          // total_healthy_view: response.healthy_views,
          // currently_recording: response['cameras'].recording_24h,

          // healthy_hdd: response['hdds'].healthy,
          // total_hdd: response['hdds'].total,


          cameras_meeting_the_recording_policy : response['cameras'].meets_policy
        });
        console.error(" fetching getMatrixCount from API, response['cameras'].offline:", this.state.series, response['cameras'].offline);
      }
    } catch (error) {
      console.error("Error fetching cameras from API:", error);
    } finally {
      this.setState({loading: false})
    }

  };

  NavigateToDevices = () => {
    this.props.navigate("/showDevices");
  }

   handleTabChange = (event, newValue) => {
  this.setState({ activeTab: newValue }, () => {
    if (newValue === 2) {
      this.fetchOfflineCameraDetails(1);
    }
  });
};


  fetchErrorRecords = async (page = 1) => {
  try {
    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`
      }
    const response = await get(`${urls.STATUS_MATRIX}?section=errors&page=${page}`, headers);
    console.log("API Response for fetchErrorRecords response:", response);
    this.setState({
      errorRecords: response.records || [],
      errorPage: response.current_page ||page,
      errorTotalPages: response.num_pages || 1
    });
  } catch (err) {
    console.error("Failed to fetch error records:", err);
  }
};

fetchWarningRecords = async (page = 1) => {
  try {
    let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
      console.log("--------auth tocken---------", access_tocken);
      let headers = {
          'content-type': 'application/json',
          'Authorization': `Bearer ${access_tocken}`
      };
    const response = await get(`${urls.STATUS_MATRIX}?section=ai_warning&page=${page}`, headers);
    console.log("API Response for fetchWarningRecords response:", response);
    this.setState({
      warningRecords: response.records || [],
      warningPage: response.current_page || page,
      warningTotalPages: response.num_pages || 1
    });
  } catch (err) {
    console.error("Failed to fetch warning records:", err);
  }
};

fetchOfflineCameraDetails = async (page = 1) => {
  try {
    let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
    let headers = {
      "content-type": "application/json",
      "Authorization": `Bearer ${access_token}`
    };

    const response = await get(urls.GET_OFFLINE_CAMERAS_LIST(page), headers);

    console.log("📌 Offline camera list:", response);

    this.setState({
      offlineCameraList: response.records || [],
      offlinePage: response.current_page || page,
      offlineTotalPages: response.num_pages || 1
    });
  } catch (err) {
    console.error("Failed to fetch offline camera details:", err);
  }
};


handlePageChange = (direction) => {
  const { activeTab, errorPage, warningPage , offlinePage} = this.state;

  if (activeTab === 0) {
    const newPage = errorPage + direction;
    if (newPage >= 1) this.fetchErrorRecords(newPage);
  } else if (activeTab === 1) {
    const newPage = warningPage + direction;
    if (newPage >= 1) this.fetchWarningRecords(newPage);
  }
    else if (activeTab === 2) {
    const newPage = offlinePage + direction;
    if (newPage >= 1) this.fetchOfflineCameraDetails(newPage);
  }
};

  formatToUSDateTime = (datetimeStr) => {
    if (!datetimeStr || typeof datetimeStr !== "string") {
    console.warn("Invalid datetime string:", datetimeStr);
    return "Invalid Date";
  }

  const date = new Date(datetimeStr);

  if (isNaN(date)) {
    console.warn("Unable to parse datetime:", datetimeStr);
    return "Invalid Date";
  }

  return new Intl.DateTimeFormat("en-US", {
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  }).format(date); // e.g., "05/15/25, 11:09 AM"
  }

NavigateToErrorDetails = (id, deviceId, SiteName, DeviceName) => {
  let camera_id = id;
  localStorage.setItem(globalVariables.CAMERA_ID, camera_id);
  localStorage.setItem(globalVariables.DEVICE_ID, deviceId);
  localStorage.setItem(globalVariables.SITE_NAME, SiteName);
  localStorage.setItem(globalVariables.DEVICE_NAME, DeviceName);
  
  this.props.navigate(`/recordDetails`);
}

//Fetch Count of car person and motorbike 
fetchObjectCounts = async (page = 1) => {
  try {
    const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
    const headers = {
      'content-type': 'application/json',
      'Authorization': `Bearer ${access_token}`,
    };

    const apiResponse = await get(urls.GET_VIDEO_ANALYTIC_OBJECT_COUNTS(page), headers);

    console.log(" Raw API response:", apiResponse); // debug
      const results = apiResponse?.results ?? {};

    // object_counts sub-block
    const counts = results?.object_counts ?? {};

    // Correct offline camera count (NOT inside object_counts)
    const alertOffline = results?.alert_camera_offline ?? 0;

    console.log("✅ Parsed object_counts:", counts); // should now log actual data

    this.setState({
      armCount: results.armed ?? 0,
      disarmCount: results.disarmed ?? 0,
      objectCounts: {
         all_camera_count: counts?.all_camera_count ?? 0,
        person: counts?.person ?? 0,
        car: counts?.car ?? 0,
        motorbike: counts?.motorbike ?? 0,
        alert_camera_offline: alertOffline, // FINAL VALUE = 52
      },
      totalAlertResolvedCount: results.alerts_cleared_last_24h ?? 0
    });
  } catch (error) {
    console.error("❌ Failed to fetch object counts:", error);
  }
};

fetchDisarmedDevices = async (page = 1) => {
  try {
    let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);

    let headers = {
      "content-type": "application/json",
      "Authorization": `Bearer ${access_token}`
    };

    const apiRes = await get(urls.GET_DISARMED_DEVICES_LIST(page), headers);
    const response = apiRes?.data || apiRes;

    console.log("📌 Disarmed devices:", response);

    this.setState({
      disarmedDevicesList: response.records || [],
      disarmedPage: response.current_page || 1,
      disarmedTotalPages: response.num_pages || 1
    });

  } catch (err) {
    console.error("❌ Failed to fetch disarmed devices:", err);
  }
};

// fetchVideoDetectionData = async (page = 1) => {
//   try {
//     const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
//     const headers = {
//       'content-type': 'application/json',
//       'Authorization': `Bearer ${access_token}`
//     };

//     const response = await get(`${urls.GET_VIDEO_ANALYTIC_OBJECT_COUNTS}?page=${page}`, headers);

//     const detectionList = response?.results?.results || []; // ✅ nested results
//     const totalCount = detectionList.length; // adjust if needed based on API count

//     this.setState({
//       videoDetectionData: detectionList,
//       videoDetectionPage: page,
//       videoDetectionTotalPages: Math.ceil((response?.count || 0) / 10),
//     });
//   } catch (err) {
//     console.error("❌ Failed to fetch video detection data:", err);
//   }
// };

fetchVideoAnalyticsChartData = async (range = '7d') => {

  try {
    const access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
    const headers = {
      'content-type': 'application/json',
      'Authorization': `Bearer ${access_token}`,
    };

    const url = urls.GET_VIDEO_ANALYTICS_STATS(range);
    const response = await get(url, headers);
    console.log(`✅ Video analytics chart data for range ${range}:`, response);
    let data = [];

    if (range === '24h') {
      if (response && typeof response === 'object' && 'all_count' in response) {
        data = [{
          ...response,
          date: 'Last 24h',
          person: response.person ?? 0,
          car: response.car ?? 0,
          motorbike: response.motorbike ?? 0,
        }];
      }
    await this.fetchObjectCounts();
    } else if (range === '7d') {
      if (Array.isArray(response?.data)) {
        data = response.data.map(d => ({
          ...d,
          person: d.person ?? 0,
          car: d.car ?? 0,
          motorbike: d.motorbike ?? 0,
          date: d.date ?? "Unknown"
        }));
      }
    }

    this.setState({ 
      videoAnalyticsChartData: data,
      videoAnalyticsRange: range 
    });

  } catch (err) {
    console.error(`❌ Error fetching video analytics chart data for range ${range}:`, err);
    this.setState({ videoAnalyticsChartData: [], videoAnalyticsRange: range });
  }
};

fetchOfflineCameras24H = async (page = 1) => {
  try {
    this.setState({ loadingOffline: true });

    const token = localStorage.getItem(globalVariables.AUTH_TOKEN);

    const response = await fetch(urls.GET_OFFLINE_CAMERAS_24H(page), {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
    });

    const data = await response.json();
    console.log("📌 Offline Camera API Response:", data);

    // Extract camera list CORRECTLY
    const cameras = Array.isArray(data?.results?.cameras)
      ? data.results.cameras
      : [];

    this.setState({
      offlineCameras24H: cameras,                // 👈 UPDATED STATE
      totalOffline24H: data?.results?.total_offline || 0,
      offlinePage: page,
      offlineTotalPages: data?.count
        ? Math.ceil(data.count / cameras.length)
        : 1,
      loadingOffline: false,
    });

  } catch (error) {
    console.error("❌ Error loading offline cameras:", error);
    this.setState({
      offlineCameras24H: [],                     // 👈 ENSURE ARRAY
      loadingOffline: false,
    });
  }
};

  convertScheduleToDateTime = (scheduleStr) => {  //function to convert the next schedule day and time to date and time
    const [dayStr, timeStr] = scheduleStr.split(" ");
    const [hours, minutes, seconds] = timeStr.split(":").map(Number);

    const daysMap = {
      Sunday: 0,
      Monday: 1,
      Tuesday: 2,
      Wednesday: 3,
      Thursday: 4,
      Friday: 5,
      Saturday: 6,
    };

    const targetDay = daysMap[dayStr];
    const now = new Date();
    const todayDay = now.getDay();

    let daysToAdd = targetDay - todayDay;
    if (daysToAdd < 0) daysToAdd += 7;

    const scheduledDate = new Date(now);
    scheduledDate.setDate(now.getDate() + daysToAdd);
    scheduledDate.setHours(hours, minutes, seconds || 0, 0);

    return scheduledDate.toLocaleString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  }

  openReleaseNotes = () => {
    // Implementation for opening release notes
    window.open("https://eyeon8i.com/release-notes/", "_blank");
  }


    render() {
      const{live_devices, total_devices, live_cameras, totalValue, healthy_view, total_healthy_view, currently_recording, healthy_hdd, total_hdd, loading, dataAvailable, activeTab, cameras_recording_policy_unmatched, hdds_unmatched, offline_cameras, time_mismatch, ai_warning} = this.state

      // const {
      //   cameras_recording_policy_unmatched_records,
      //   hdds_unmatched_records,
      //   offline_cameras_records,
      //   time_mismatch_records,
      //   ai_warning_records
      // } = this.state;

      // const labelRecords = (records, label) =>
      // (records || []).map(r => ({ ...r, error_type: label }));

    // const allErrorRecords = [
    //   ...labelRecords(cameras_recording_policy_unmatched_records, "Recording Policy Unmatched"),
    //   ...labelRecords(hdds_unmatched_records, "HDD Unmatched"),
    //   ...labelRecords(offline_cameras_records, "Camera Offline"),
    //   ...labelRecords(time_mismatch_records, "Timezone Mismatch"),
    // ];

    // const allWarningRecords = (ai_warning_records || []).map(r => ({
    //   ...r,
    //   error_type: `Image rating: ${r.ai_rating}`,
    // }));

    //-------------section used for chart and progress bar design----------------
      // Calculate the percentage of active devices
    // const activeDevicePercentage = total_devices > 0 ? Math.round((live_devices / total_devices) * 100) : 0;

    // const liveCameraePercentage = totalValue > 0 ? Math.round((live_cameras / totalValue) * 100) : 0;

    // const healthyHddPercentage = total_hdd > 0 ? Math.round((healthy_hdd / total_hdd) * 100) : 0;

    // const healthyOperatorRating = total_healthy_view > 0 ? Math.round((healthy_view / totalValue) * 100) : 0;

    // const cameras_recording_24hrs = totalValue > 0 ? Math.round((currently_recording / totalValue) * 100) : 0;

    // const cameras_count_meeting_the_recording_policy = totalValue > 0 ? Math.round((this.state.cameras_meeting_the_recording_policy / totalValue) * 100) : 0;

    // console.log("Rendering Home.jsx with state:", this.state);       

        return (
          <ThemeProvider theme={darkTheme}>
            <CssBaseline />
            <div className="home-page">
              <style>{`
                .home-page {
                  min-height: 100vh;
                  overflow-x: hidden;
                }

                .home-content {
                  min-width: 0;
                }

                .home-body {
                  height: 100vh;
                }

                .home-column {
                  min-width: 0;
                  width: 47%;
                }

                .home-page .MuiTableContainer-root {
                  max-width: 100%;
                  overflow-x: auto;
                  overscroll-behavior-x: contain;
                  -webkit-overflow-scrolling: touch;
                }

                @media (max-width: 768px) {
                  .home-welcome {
                    min-height: 72px;
                    height: auto !important;
                  }

                  .home-content {
                    width: auto !important;
                    height: auto !important;
                    min-height: calc(100vh - 100px);
                    flex-direction: column !important;
                    gap: 24px !important;
                    margin-left: 68px !important;
                    margin-right: 8px;
                  }

                  .home-body {
                    height: auto;
                  }

                  .home-column {
                    width: 100%;
                  }

                  .home-page .MuiTable-root {
                    min-width: 620px;
                  }

                  .home-page .MuiTabs-root .MuiTab-root {
                    min-width: 0;
                    padding-left: 6px;
                    padding-right: 6px;
                    font-size: 0.72rem;
                  }

                  .home-pagination {
                    flex-wrap: wrap;
                    gap: 8px;
                  }

                  .home-pagination .MuiTypography-root {
                    flex: 1 1 auto;
                    text-align: center;
                  }

                  .home-empty-state {
                    margin-left: 0 !important;
                    padding: 24px 12px;
                    text-align: center;
                  }

                  .home-empty-state h1 {
                    font-size: 1.35rem;
                  }

                  .navbar-container:not(.collapsed) + .home-body .home-welcome,
                  .navbar-container:not(.collapsed) + .home-body .home-content {
                    margin-left: 190px !important;
                  }

                  .navbar-container.collapsed + .home-body .home-welcome,
                  .navbar-container.collapsed + .home-body .home-content {
                    margin-left: 68px !important;
                  }
                }

                @media (max-width: 480px) {
                  .home-page .MuiTable-root {
                    min-width: 560px;
                  }
                }

                .red-dot {
                  width: 9px;
                  height: 9px;
                  background-color: red;
                  border-radius: 50%;
                  position: absolute;
                  top: -2px;
                  right: -2px;
                  border: 2px solid white;
                  animation: pulse 1s infinite;
                }

                /* GREY DOT FOR OFFLINE / DISARMED */
                .grey-dot {
                  width: 9px;
                  height: 9px;
                  background-color: grey;   /* <-- grey color */
                  border-radius: 50%;
                  position: absolute;
                  top: -2px;
                  right: -2px;
                  border: 2px solid white;
                }

                @keyframes pulse {
                  0% { transform: scale(1); opacity: 0.7; }
                  50% { transform: scale(1.3); opacity: 1; }
                  100% { transform: scale(1); opacity: 0.7; }
                }
              `}</style>
              <Navigationbar />
              <div className="home-body">
                <Box className="home-welcome" component={Paper} elevation={3} sx={{ marginLeft:{ xs: '68px', md: '9.7%' }, marginTop:'1%', marginRight:{ xs: 1, sm: 2, md: '2%' }, padding: { xs: 1, sm: '5px' }, height: '8vh', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, alignItems: { xs: 'flex-start', sm: 'center' }, justifyContent: 'space-between', gap: { xs: 0.5, sm: 1 }, borderBottom: '2px solid #4172c0' }}>
                    <Typography variant="h6" fontWeight="bold" sx={{padding: { xs: 0, sm: '5px' }, color: '#fff', fontSize: { xs: '1rem', sm: '1.25rem' }}}>
                        Welcome , {localStorage.getItem(globalVariables.USER_NAME) || "User"}!
                    </Typography>
                    <Typography variant="subtitle1" sx={{ marginLeft: { xs: 0, sm: 2 }, color: '#8facd5', fontSize: { xs: '0.78rem', sm: '1rem' }, lineHeight: 1.35 }}>
                      Great job! You have cleared <b style={{color: '#c7deff'}}> {this.state.totalAlertResolvedCount}</b> alerts in last 24 hrs cycle!
                    </Typography>
                    {/* <Button onClick={this.openReleaseNotes}> Release Notes</Button> */}
                </Box>
                  <div className="home-content" style={{ display: 'flex', flexDirection:'row', gap:'50px',height: '97vh', marginTop:'1.8%', width: '90%', marginLeft:'9.7%'}}>
                  {loading ? (
                        <h2 style={{marginLeft:'15%', display:'flex', alignContent:'center'}}>Loading...</h2>
                    ) : dataAvailable ? (
                        <>
                          <div className="home-column">
                            
                            <TableContainer component={Paper} sx={{ border: '1px solid #5b6e87' }}>
                              <Table >
                                <TableHead >
                                  <h3 style={{marginLeft:'3%', whiteSpace: 'nowrap', color:'#a4c4f1'}}> Camera Health Analysis</h3>                                
                                  <TableRow>
                                    {[
                                      'Last 24 Hours',
                                      <CheckCircleIcon color="success" sx={{ fontSize: 30 }} />,
                                      <CancelIcon color="warning" sx={{ fontSize: 30 }} />,
                                      <ErrorRoundedIcon color="warning" sx={{ fontSize: 30 }} />,
                                      <CancelIcon color="error" sx={{ fontSize: 30 }} />,
                                      
                                      ].map((header) => (
                                      <TableCell key={header} align="center">
                                          <Typography variant="subtitle2" fontWeight="bold">
                                          {header}
                                          </Typography>
                                      </TableCell>
                                      ))}
                                  </TableRow>
                                  <TableRow style={{ height: 50 }}>
                                    <TableCell align="center" >
                                      Total Cameras <br/><b>{totalValue}</b>
                                    </TableCell>
                                    <TableCell align="center" style={{whiteSpace: 'nowrap'}}>
                                      Live Cameras <br/><b>{live_cameras}</b>
                                    </TableCell>
                                    {/* <TableCell align="center" style={{whiteSpace: 'nowrap'}}>
                                      Offline Cameras <br/><b>{offline_cameras}</b>
                                    </TableCell> */}
                                    <TableCell
                                      align="center"
                                      style={{ whiteSpace: "nowrap", cursor: "pointer" }}
                                      onClick={() => {
                                        this.setState({ activeTab: 2 }, () => {
                                          this.fetchOfflineCameraDetails(1);   // fetch AFTER tab is active
                                        });
                                      }}
                                    >
                                      Offline Cameras <br />
                                      <b style={{ color: "#0077cc" }}>{offline_cameras}</b>
                                    </TableCell>


                                    <TableCell align="center" >
                                      Warning <b>{ai_warning}</b>
                                    </TableCell>
                                    <TableCell align="center" >
                                      Error <b>{(Number(cameras_recording_policy_unmatched) || 0) + (Number(hdds_unmatched) || 0) + (Number(offline_cameras) || 0) + (Number(time_mismatch) || 0)}</b>
                                      {/* {cameras_recording_policy_unmatched} cameras_recording_policy_unmatched, hdds_unmatched, offline_cameras, time_mismatch */}
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                              </Table>
                            </TableContainer>
                            <Box sx={{ marginTop: 2 }}>
                              {/* Subtab Bar */}
                              <Tabs
                                value={activeTab}
                                onChange={this.handleTabChange}
                                indicatorColor="primary"
                                textColor="black"
                                variant="fullWidth"
                                component={Paper}
                              >
                                <Tab label="Error" sx={{
                                  backgroundColor: activeTab === 0 ? "#8ea1b5" : "#191e29",
                                  color: activeTab === 0 ? "#000" : "inherit",
                                  fontWeight: activeTab === 0 ? 550 : 500
                                }} />
                                <Tab label="Warning" sx={{
                                  backgroundColor: activeTab === 1 ? "#8ea1b5" : "#191e29",
                                  color: activeTab === 1 ? "#000" : "inherit",
                                  fontWeight: activeTab === 1 ? 550 : 500
                                }}/>
                                <Tab label="Offline Cameras" sx={{
                                  backgroundColor: activeTab === 2 ? "#8ea1b5" : "#191e29",
                                  color: activeTab === 2 ? "#000" : "inherit",
                                  fontWeight: activeTab === 2 ? 550 : 500
                                }}/>
                              </Tabs>
                                <>
                                  {/* Tab Content */}
                                  <Box sx={{ marginTop: 0.5,
                                    display: 'block',
                                    maxHeight: 380, // Adjust height as needed
                                    overflowY: 'auto',
                                    "&::-webkit-scrollbar": { width: "5px" },
                                    "&::-webkit-scrollbar-thumb": {
                                      backgroundColor: "#1976d2",
                                      borderRadius: "8px",
                                    },
                                  }}>
                                    {activeTab === 0 && (
                                    <>
                                      <TableContainer component={Paper} 
                                      sx={{ 
                                        maxHeight: 370, overflowY: "auto", borderTop:"2px solid #4172c0",
                                        "&::-webkit-scrollbar": { width: "5px" },
                                        "&::-webkit-scrollbar-thumb": {
                                          backgroundColor: "#1976d2",
                                          borderRadius: "8px",
                                        },
                                        }} >
                                      <Table stickyHeader>
                                          <TableHead
                                            sx={{
                                              position: "sticky",
                                              top: 0,
                                              zIndex: 2,
                                              // backgroundColor: "#f5f5f5",
                                              // "& .MuiTableCell-head": {
                                              //   backgroundColor: "#1a2025",
                                              //   color: "#fff",
                                              // },
                                            }}
                                          >
                                          <TableRow>
                                              {[
                                              'Site Name',
                                              'Device Name',
                                              'Camera',
                                              'Date',
                                              'Error',
                                              ].map((header) => (
                                              <TableCell key={header} align="center" 
                                                sx={{backgroundColor:"#242b39",
                                                borderBottom: "1px solid #939fb1"
                                                }}>
                                                  <Typography variant="subtitle2" fontWeight="bold" >
                                                  {header}
                                                  </Typography>
                                              </TableCell>
                                              ))}
                                          </TableRow>
                                          </TableHead>
                                          <TableBody>
                                              {this.state.errorRecords.length === 0 ? (
                                                <TableRow>
                                                  <TableCell colSpan={4} align="center">
                                                    No error records found.
                                                  </TableCell>
                                                </TableRow>
                                              ) : (
                                                <>
                                                  {this.state.errorRecords.map((record, index) => {
                                                    // Determine error label
                                                    let errorType = 'Error';

                                                    if (record.timezone_match === false) {
                                                      errorType = 'Timezone Mismatch';
                                                    } else if ('recording_days' in record) {
                                                      errorType = 'Recording Policy Mismatch';
                                                    }
                                                    else if (record.status === 'offline') {
                                                      errorType = 'Camera is offline';
                                                    }
                                                    else {
                                                      // errorType = `HDD issue (${record.disk_id}:${record.status})`;
                                                      // if (record?.error_type) {
                                                      //   errorType += `- ${record.error_type.replace(/ _/g, ' ')}`; // Use specific error type if provided by API
                                                      // }
                                                      if (record?.error_type === "no_disk_available") {
                                                        errorType = "HDD issue - No disk available";
                                                      } else {
                                                        errorType = `HDD issue (${record.disk_id}:${record.status})`;

                                                        if (record?.error_type) {
                                                          errorType += ` - ${record.error_type.replace(/_/g, ' ')}`;
                                                        }
                                                      }
                                                    }

                                                    return (
                                                      <TableRow key={index}>
                                                        <TableCell align="center">{record?.sitedb__sitename || 'N/A'}</TableCell>
                                                        <TableCell align="center">{record?.device_name || '--'}</TableCell>
                                                        <TableCell align="center">{record?.camera_name || '--'}</TableCell>
                                                        <TableCell align="center">{this.formatToUSDateTime(record.updated_at) || '--'}</TableCell>
                                                        <TableCell align="center" style={{ color: 'red'}} 
                                                        //  onClick={() => this.NavigateToErrorDetails(record.id, record.device__id, record.sitedb__sitename, record.device_name)}
                                                        > 
                                                          {errorType|| '--'}
                                                        </TableCell>
                                                      </TableRow>
                                                    );
                                                  })}
                                                </>
                                              )}
                                          </TableBody>
                                      </Table>
                                      </TableContainer>
                                    </>
                                    )}
                                    {activeTab === 1 && <Box component={Paper} > 
                                      <>
                                      <TableContainer component={Paper} 
                                      sx={{ 
                                        maxHeight: 380, overflowY: "auto", borderTop:"2px solid #4172c0",
                                        "&::-webkit-scrollbar": { width: "5px" },
                                        "&::-webkit-scrollbar-thumb": {
                                          backgroundColor: "#1976d2",
                                          borderRadius: "8px",
                                        },
                                      }} >
                                      <Table stickyHeader>
                                          <TableHead
                                              sx={{
                                                position: "sticky",
                                                top: 0,
                                                zIndex: 2,
                                                // backgroundColor: "#f5f5f5",
                                                // "& .MuiTableCell-head": {
                                                //     backgroundColor: "#1a2025",
                                                //     color: "#fff",
                                                //   },
                                              }}
                                            >
                                          <TableRow sx={{backgroundColor:"#1a2025"}}>
                                              {[
                                              
                                              'Site Name',
                                              'Device Name',
                                              'Camera',
                                              'Date',
                                              'Error',
                                              ].map((header) => (
                                              <TableCell key={header} align="center"
                                              sx={{backgroundColor:"#242b39",
                                                borderBottom: "1px solid #939fb1"
                                                }}
                                              >
                                                  <Typography variant="subtitle2" fontWeight="bold">
                                                  {header}
                                                  </Typography>
                                              </TableCell>
                                              ))}
                                          </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {this.state.warningRecords.length === 0 ? (
                                                <TableRow>
                                                  <TableCell colSpan={4} align="center">
                                                    No error records found.
                                                  </TableCell>
                                                </TableRow>
                                              ) : (
                                                <>
                                                  {this.state.warningRecords.map((record, index) => {
                                                    // Determine error label
                                                    let errorType = record.ai_rating;

                                                    // if (record.timezone_match === false) {
                                                    //   errorType = 'Timezone Mismatch';
                                                    // } else if ('recording_days' in record) {
                                                    //   errorType = 'Recording Policy Mismatch';
                                                    // }

                                                    return (
                                                      <TableRow key={index}>
                                                        <TableCell align="center">{record?.sitedb__sitename || 'N/A'}</TableCell>
                                                        <TableCell align="center">{record?.device_name || 'N/A'}</TableCell>
                                                        <TableCell align="center">{record?.camera_name || 'N/A'}</TableCell>
                                                        <TableCell align="center">{this.formatToUSDateTime(record.updated_at) || '--'}</TableCell>
                                                        <TableCell align="center" style={{ color: 'red' }}>
                                                          Image is {errorType}
                                                        </TableCell>
                                                      </TableRow>
                                                    );
                                                  })}
                                                </>
                                              )}
                                          </TableBody>
                                      </Table>
                                      </TableContainer>
                                    </>
                                    </Box>}
                                    {activeTab === 2 && (
                                      <TableContainer component={Paper} 
                                        sx={{
                                          maxHeight: 380, overflowY: "auto", borderTop:"2px solid #4172c0",
                                          "&::-webkit-scrollbar": { width: "5px" },
                                          "&::-webkit-scrollbar-thumb": {
                                            backgroundColor: "#1976d2",
                                            borderRadius: "8px",
                                          },
                                        }}>
                                        <Table stickyHeader>
                                          <TableHead
                                            sx={{
                                              position: "sticky",
                                              top: 0,
                                              zIndex: 2,
                                              // backgroundColor: "#f5f5f5",
                                              // "& .MuiTableCell-head": {
                                              //   backgroundColor: "#1a2025",
                                              //   color: "#fff",
                                              // },
                                            }}
                                          >
                                            <TableRow>
                                              {["Site Name", "Device Name", "Camera Name", "Timestamp"].map((header) => (
                                                <TableCell align="center" key={header}
                                                sx={{backgroundColor:"#242b39",
                                                borderBottom: "1px solid #939fb1"
                                                }}
                                                >
                                                  <Typography variant="subtitle2" fontWeight="bold">{header}</Typography>
                                                </TableCell>
                                              ))}
                                            </TableRow>
                                          </TableHead>

                                          <TableBody>
                                            {this.state.offlineCameraList.length === 0 ? (
                                              <TableRow>
                                                <TableCell colSpan={4} align="center">No offline cameras found.</TableCell>
                                              </TableRow>
                                            ) : (
                                              this.state.offlineCameraList.map((cam, index) => (
                                                <TableRow key={index}>
                                                  <TableCell align="center">{cam?.sitedb__sitename || "N/A"}</TableCell>
                                                  <TableCell align="center">{cam?.device_name || "--"}</TableCell>
                                                  <TableCell align="center">{cam?.camera_name || "--"}</TableCell>
                                                  <TableCell align="center">{this.formatToUSDateTime(cam.updated_at) || "--"}</TableCell>
                                                </TableRow>
                                              ))
                                            )}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    )}
                                  </Box>
                                  <Box className="home-pagination" sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
                                    <Button
                                      variant="contained"
                                      id="ErrorLogsPerPageButton"
                                      onClick={() => this.handlePageChange(-1)}
                                      size='small'
                                      disabled={
                                        (activeTab === 0 && this.state.errorPage === 1) ||
                                        (activeTab === 1 && this.state.warningPage === 1)
                                      }
                                    >
                                      Previous
                                    </Button>
                                    {/* PAGE NUMBER DISPLAY */}
                                    <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                      Page {
                                        activeTab === 0 ? this.state.errorPage :
                                        activeTab === 1 ? this.state.warningPage :
                                        activeTab === 2 ? this.state.offlinePage : 1
                                      }
                                      {" "}
                                      of {
                                        activeTab === 0 ? this.state.errorTotalPages :
                                        activeTab === 1 ? this.state.warningTotalPages :
                                        activeTab === 2 ? this.state.offlineTotalPages : 1
                                      }
                                    </Typography>

                                    <Button 
                                      variant="contained" 
                                      id="ErrorLogsPerPageButton"
                                      onClick={() => this.handlePageChange(1)}
                                      size='small'
                                      disabled={
                                        (activeTab === 0 && this.state.errorPage >= this.state.errorTotalPages) ||
                                        (activeTab === 1 && this.state.warningPage >= this.state.warningTotalPages)||
                                        (activeTab === 2 && this.state.offlinePage  >= this.state.offlineTotalPages)}
                                      >
                                      Next
                                    </Button>
                                  </Box>

                                </>
                            </Box>
                          </div>
                          <div className="home-column">
                            <TableContainer component={Paper} sx={{ border: '1px solid #5b6e87' }}>
                              <Table>
                                <TableHead>
                                  <h3 style={{marginLeft:'3%',whiteSpace: 'nowrap', color:'#a4c4f1'}}> Video Analysis</h3>
                                  <TableRow>
                                    {[
                                      'Last 24 Hours',
                                      // ARMED — VIDEO ICON WITH RED DOT
                                    <span style={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
                                      <VideocamIcon
                                        sx={{
                                          backgroundColor: "#2196f3", // BLUE
                                          color: "white",
                                          borderRadius: "50%",
                                          padding: "4px",
                                          fontSize: 30
                                        }}
                                      />
                                      <span className="red-dot"></span>
                                    </span>,

                                    // DISARMED — DISABLED VIDEO ICON WITH GREY DOT
                                    <span style={{ position: "relative", display: "inline-flex", alignItems: "center" }}>
                                      <VideocamIcon
                                        sx={{
                                          backgroundColor: "#515456ff", // BLUE
                                          color: "white",
                                          borderRadius: "50%",
                                          padding: "4px",
                                          fontSize: 30
                                        }}
                                      />
                                      <span className="grey-dot"></span>
                                    </span>
  ,
                                      <span>
                                        <DirectionsCarFilledRounded 
                                          sx={{
                                            backgroundColor: "#639fd3",
                                            color: "white",
                                            borderRadius: "50%",
                                            padding: "3px",
                                            fontSize: 30, 
                                          }}
                                        />
                                      </span>,
                                      <span>
                                        <DirectionsWalkRounded
                                          sx={{
                                            backgroundColor: "#44c54c",
                                            color: "white",
                                            borderRadius: "50%",
                                            padding: "3px",
                                            fontSize: 30, // optional
                                          }}
                                        />
                                      </span>,
                                      <span>
                                        <TwoWheelerRounded 
                                          sx={{
                                            backgroundColor: "#de45f5ff",
                                            color: "white",
                                            borderRadius: "50%",
                                            padding: "3px",
                                            fontSize: 30, // optional
                                          }}
                                        />
                                      </span>,
                                      
                                      ].map((header) => (
                                      <TableCell key={header} align="center">
                                          <Typography variant="subtitle2" fontWeight="bold">
                                          {header}
                                          </Typography>
                                      </TableCell>
                                      ))}
                                  </TableRow>
                                    <TableRow style={{ height: 75 }}>

                                    <TableCell align="center" style={{whiteSpace: "nowrap"}}>
                                      Analysing <b>{this.state.objectCounts.all_camera_count}</b> Cameras
                                      
                                    </TableCell>

                                    <TableCell align="center">
                                      <b>{this.state.armCount}</b>
                                    </TableCell>

                                    <TableCell
                                    align="center"
                                    // onClick={() => {
                                    //   this.fetchOfflineCameras24H(1);   // fetch list
                                    //   this.setState({ showOfflineDetails: true });  // show chart/table
                                    // }}
                                    onClick={() => {
                                      this.fetchDisarmedDevices();
                                      this.setState({ selectedVideoTab: 0 });  // NEW TAB
                                    }}
                                    // style={{ cursor: "pointer" }}
                                  >
                                    {/* <b>{this.state.objectCounts?.disarmed || 0}</b> */}
                                    {/* // <b style={{ whiteSpace: "nowrap", cursor: "pointer", color: "#0077cc", }}>{this.state.disarmCount?.disarmed || 0}</b> */}
                                    <b style={{ whiteSpace: "nowrap", cursor: "pointer", color: "#0077cc", }}>{this.state.disarmCount}</b>
                                    </TableCell> 

                                    <TableCell align="center">
                                      <b>{this.state.objectCounts.car}</b>
                                    </TableCell>

                                    <TableCell align="center">
                                      <b>{this.state.objectCounts.person}</b>
                                    </TableCell>

                                    <TableCell align="center">
                                      <b>{this.state.objectCounts.motorbike}</b>
                                    </TableCell>

                                  </TableRow>
                                </TableHead>
                              </Table>
                            </TableContainer>
                            <Box sx={{ marginTop: 2 }}>

                              {/* 🔵 ALWAYS SHOW TABS */}
                              <Box sx={{ width: "100%", display: "flex" }}>
                                <Box sx={{ width: "100%" }}>
                                  <Tabs
                                    value={this.state.selectedVideoTab}
                                    onChange={(e, v) => {
                                      this.setState({
                                        selectedVideoTab: v,
                                        showOfflineDetails: v === 0   // show table only when unstable selected
                                      });

                                      if (v === 0) this.fetchDisarmedDevices(1);
                                      if (v === 1) this.fetchVideoAnalyticsChartData("24h");
                                      if (v === 2) this.fetchVideoAnalyticsChartData("7d");
                                    }}
                                    indicatorColor="primary"
                                    textColor="black"
                                    variant="fullWidth"
                                    component={Paper}
                                  >
                                    <Tab label="Disarmed Sites" 
                                      value={0} 
                                      sx={{
                                        backgroundColor: this.state.selectedVideoTab === 0 ? "#8ea1b5" : "#191e29",
                                        color: this.state.selectedVideoTab === 0 ? "#000" : "inherit",
                                        fontWeight: this.state.selectedVideoTab === 0 ? 550 : 500
                                      }} 
                                    />
                                    <Tab label="24 HOURS" 
                                    value={1}
                                    sx={{
                                        backgroundColor: this.state.selectedVideoTab === 1 ? "#8ea1b5" : "#191e29",
                                        color: this.state.selectedVideoTab === 1 ? "#000" : "inherit",
                                        fontWeight: this.state.selectedVideoTab === 1 ? 550 : 500
                                      }}  
                                    />
                                    <Tab label="7 DAYS" 
                                    value={2}
                                    sx={{
                                        backgroundColor: this.state.selectedVideoTab === 2 ? "#8ea1b5" : "#191e29",
                                        color: this.state.selectedVideoTab === 2 ? "#000" : "inherit",
                                        fontWeight: this.state.selectedVideoTab === 2 ? 550 : 500
                                      }}  
                                    />
                                  </Tabs>
                                </Box>
                              </Box>



                              {/* 🔵 IF SELECTED 1 OR 2 → SHOW CHART */}
                              
                              {(this.state.selectedVideoTab === 1 || this.state.selectedVideoTab === 2) && (
                                <Box
                                  sx={{
                                    border: "1px solid #2f3b52",
                            
                                    
                                  }}
                                  component={Paper}
                                >
                                
                                <>
                                  {Array.isArray(this.state.videoAnalyticsChartData) &&
                                  this.state.videoAnalyticsChartData.length === 0 ? (

                                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" height={200}
                                    sx={{borderTop:"2px solid #4172c0"}}>
                                      <Typography variant="body1" color="textSecondary">
                                        No detection data available for the selected time range.
                                      </Typography>
                                    </Box>

                                  ) : (
                                    <Box sx={{ marginTop: "7px", borderTop:"2px solid #4172c0", }}>
                                      <Chart
                                        type="bar"
                                        height={350}
                                        series={[
                                          { name: 'Person', data: this.state.videoAnalyticsChartData.map((d) => d.person || 0) },
                                          { name: 'Car', data: this.state.videoAnalyticsChartData.map((d) => d.car || 0) },
                                          { name: 'Motorbike', data: this.state.videoAnalyticsChartData.map((d) => d.motorbike || 0) },
                                        ]}
                                        options={{
                                          chart: { type: 'bar', stacked: true, toolbar: { show: false }, background: "transparent", },
                                          plotOptions: { bar: { horizontal: false, columnWidth: '60%', endingShape: 'rounded' } },
                                          dataLabels: { enabled: true, style: { colors: ['#000'] } },
                                          xaxis: {
                                            categories: this.state.videoAnalyticsChartData.map((d) => {
                                              const dateStr = d.date ?? "Unknown";
                                              const date = new Date(dateStr);
                                              return isNaN(date)
                                                ? dateStr
                                                : date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
                                            }),
                                            labels: { rotate: -45, style: { fontSize: '13px', fontWeight: 500, colors: '#b5c1d2' } },
                                          },
                                          theme: {
                                            mode: "dark", // 🔥 IMPORTANT
                                          },
                                          yaxis: { title: { text: 'Object Detections' } },
                                          fill: { opacity: 1 },
                                          colors: ['#52f55d', '#80c4ff', '#e84bff'],
                                          legend: { position: 'top', horizontalAlign: 'right' },
                                        }}
                                      />
                                    </Box>
                                  )}
                                </>
                                </Box>
                              )}
                              

                            {/* 🔴 IF SELECTED 0 → SHOW DISARMED SITES TABLE */}
                            {this.state.selectedVideoTab === 0 && (
                            <Box sx={{ marginTop: 1 }}>

                              <TableContainer component={Paper} 
                                sx={{ 
                                  maxHeight: 369, overflowY: "auto", borderTop:"2px solid #4172c0",
                                  "&::-webkit-scrollbar": { width: "5px" },
                                  "&::-webkit-scrollbar-thumb": {
                                    backgroundColor: "#1976d2",
                                    borderRadius: "8px",
                                  },
                                }}>
                                <Table stickyHeader style={{ tableLayout: 'auto', width: '100%'}}>
                                  
                                <TableHead stickyHeader>
                                    <TableRow>
                                      {[
                                        "Site Name",
                                        "Device Name",
                                        "Disarmed By",
                                        "Disarmed Date",
                                        "Next Schedule",
                                        "Status",
                                      ].map((header) => (
                                        <TableCell key={header} align="center" 
                                        sx={{
                                          backgroundColor:"#242b39",
                                          borderBottom: "1px solid #939fb1"
                                        }}>
                                          <Typography variant="subtitle2" fontWeight="bold">
                                            {header}
                                          </Typography>
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>

                                  <TableBody>
                                    {Array.isArray(this.state.disarmedDevicesList) &&
                                    this.state.disarmedDevicesList.length > 0 ? (
                                      
                                      this.state.disarmedDevicesList.map((device, index) => (
                                        <TableRow key={index}>

                                          <TableCell align="center">
                                            {device?.site_name || "N/A"}
                                          </TableCell>

                                          <TableCell align="center">
                                            {device?.device_name || "--"}
                                          </TableCell>

                                          <TableCell align="center">
                                            {device?.log_changed_by || "--"}
                                          </TableCell>

                                          {/* <TableCell align="center">
                                            {this.formatToUSDateTime(camera?.log_changed_at) || "--"}
                                          </TableCell> */}
                                          <TableCell align="center">
                                            {device?.log_changed_at 
                                              ? this.formatToUSDateTime(device.log_changed_at)
                                              : <p style={{color:'red'}}>Never Turned On</p>}
                                          </TableCell>

                                          <TableCell align="center">
                                            {/* {camera?.next_schedule || "--"} */}
                                            {(device?.device_status === "inactive" ? "--" : (device?.next_schedule ? this.convertScheduleToDateTime(device.next_schedule) : 'Schedule is not set'))}
                                            {/* {device?.next_schedule ? this.convertScheduleToDateTime(device.next_schedule) : 'Schedule is not set'} */}
                                          </TableCell>

                                          <TableCell align="center">
                                            <span style={{color: (device?.status === "active" && device?.device_status === "active") ? "white" : "red"}}>{(((device?.status === "active" || device?.status === "online" ) && device?.device_status === "active") ? "Online" : (device?.device_status === "inactive" ? "Inactive" : "Offline")) || "--"}</span>
                                          </TableCell>
                                        </TableRow>
                                      ))
                                      // <TableRow>
                                      //   <TableCell colSpan={4} align="center" sx={{ padding: "20px" }}>
                                      //   In progress...
                                      //   </TableCell>
                                      // </TableRow>

                                    ) : (
                                      <TableRow>
                                        <TableCell colSpan={4} align="center" sx={{ padding: "20px" }}>
                                          No Disarmed Sites found.
                                        </TableCell>
                                      </TableRow>
                                    )}
                                  </TableBody>

                                </Table>
                              </TableContainer>

                              {/* Pagination SAME as Error/Warning */}
                              <Box className="home-pagination" sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}>
                                <Button
                                  variant="contained"
                                  id="ErrorLogsPerPageButton"
                                  onClick={() => this.fetchDisarmedDevices(this.state.disarmedPage - 1)}
                                  size="small"
                                  disabled={this.state.disarmedTotalPages <= 1 || this.state.disarmedPage === 1}
                                >
                                  PREVIOUS
                                </Button>
                                {/* PAGE NUMBER DISPLAY */}
                                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                  Page {this.state.disarmedPage} of {this.state.disarmedTotalPages}
                                </Typography>
                                <Button
                                  variant="contained"
                                  id="ErrorLogsPerPageButton"
                                  onClick={() => this.fetchDisarmedDevices(this.state.disarmedPage + 1)}
                                  size="small"
                                  disabled={this.state.disarmedPage >= this.state.disarmedTotalPages}
                                >
                                  NEXT
                                </Button>
                              </Box>

                            </Box>

                            )}


                            </Box>
                          </div>
                        </>
                    ) : (
                      <div className="home-empty-state" style={{marginLeft:'15%', display:'flex', justifyContent:'center', alignContent:'center'}}>
                          <h1>No device is configured! Setup devices or contact the Admin.</h1>
                      </div>
                  )}
                  
                  </div>
              </div>
            </div>
          </ThemeProvider>
        );
    }

}
export default withNavigate(Home);
